/**
 * Format a number as USD currency with exactly 2 decimal places
 * @param value - The number to format
 * @param showCents - Whether to show cents (default: true)
 * @returns Formatted currency string like "$1,234.56"
 */
export const formatCurrency = (value: number | undefined | null, showCents: boolean = true): string => {
  if (value === undefined || value === null || isNaN(value)) return '$0.00';
  
  const options: Intl.NumberFormatOptions = showCents 
    ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    : { minimumFractionDigits: 0, maximumFractionDigits: 0 };
  
  return '$' + value.toLocaleString('en-US', options);
};

/**
 * Format a number as USD currency without cents (for large amounts)
 * @param value - The number to format
 * @returns Formatted currency string like "$1,234"
 */
export const formatCurrencyWhole = (value: number | undefined | null): string => {
  return formatCurrency(value, false);
};

/**
 * Format a number as compact currency (K, M, B)
 * @param value - The number to format  
 * @returns Formatted string like "$1.2M"
 */
export const formatCurrencyCompact = (value: number | undefined | null): string => {
  if (value === undefined || value === null || isNaN(value)) return '$0';
  
  if (value >= 1000000000) {
    return '$' + (value / 1000000000).toFixed(1) + 'B';
  } else if (value >= 1000000) {
    return '$' + (value / 1000000).toFixed(1) + 'M';
  } else if (value >= 1000) {
    return '$' + (value / 1000).toFixed(1) + 'K';
  }
  return formatCurrency(value);
};

export default formatCurrency;
